import getDefaultAdminValues from "./default-admin-values";

export default ({ hasAdminPrivileges }) => ({
  title: "",
  description: "",
  keywords: [],
  visible: false,
  billable: false,
  ...getDefaultAdminValues(hasAdminPrivileges),
});
